// SharedDynamicModalWrapper.tsx
import React from "react";
import SharedDynamicModal from "./SharedModal";
import useSharedDynamicModal from "../../../hooks/useSharedDynamicModal";

const SharedDynamicModalWrapper: React.FC = () => {
  const {
    open,
    confirm,
    message,
    size,
    fetchHook,
    hookParams,
    component,
    title,
    confirmButton,
    cancelButton,
    type,
    closeSharedDynamicModal,
  } = useSharedDynamicModal();

  return (
    <>
      <SharedDynamicModal
        open={open ? open : false}
        size={size}
        handleClose={()=>{closeSharedDynamicModal()}}
        message={message}
        component={component}
        title={title}
        confirmButton={confirmButton}
        cancelButton={cancelButton}
        fetchHook={fetchHook}
        hookParams={hookParams}
        isFormModal={false}
        type={type}
      />
    </>
  );
};

export default SharedDynamicModalWrapper;
